import { FC } from "react";

interface FooterProps {
  
}
 
type NewType = FC<FooterProps>;

const Footer: NewType = () => {

  const date = new Date()
  const year = date.getFullYear()

  return (
    <div className="bloc bgc-black-2 d-bloc full-width-bloc" id="bloc-5">
      <div className="container bloc-lg bloc-sm-lg">
        <div className="row">
          <div className="col">
            <p
              className="text-lg-center p-bloc-5-style text-center animated zoomIn"
              data-appear-anim-style="zoomIn"
            >
              Copyright © {year} UAC Inc. / Universal Applications Consulting.
              All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
 
export default Footer;